import { ShopSectionsSlice } from "./types";

export const initialState: ShopSectionsSlice = {
	shopSections: {
		mainShopSections: [],
		loyaltyShopSections: []
	}
};
